var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo-link",attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("@/assets/new-design/img/logo/logo--dark.svg"),"alt":"МТС ЛИНК","width":"68","height":"26"}})])
}]

export { render, staticRenderFns }